import css from './services.module.scss';
import { createSearchParams, Link, useNavigate } from 'react-router-dom';
import { GLOBAL_SEARCH } from 'src/constants/routes';
import ServiceCard from 'src/pages/services/cards/service-card';
import { Service } from 'src/types';
import { fireEvent } from 'src/utils/analytics/google';
import { openInNewTab } from 'src/utils/helper';
import { Carousel } from 'src/components/carousel/carousel';
import { useGetServices } from '../data/queries';
import { tabOptions, Tabs } from '../selected-materials/selected-materials';

import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';

export default function Services({ type }: Readonly<{ type: Tabs }>) {
  const { data: services = [] } = useGetServices({ type });

  const navigate = useNavigate();
  const baseUrl = window.location.origin;

  function onServiceClick(service: Partial<Service>) {
    const url = service.url;
    fireEvent('view_service', { title: service.title, url });

    if (service.phone) {
      openInNewTab(`tel:${service.phone}`);
      return;
    }

    if (!(url?.startsWith(baseUrl) || url?.startsWith('/'))) {
      openInNewTab(url);
      return;
    }

    navigate(url, {
      state: { slug: service.slug }
    });
  }

  return (
    <div className={css.services}>
      <div className={css.container}>
        <Carousel
          data={services.map((s: Service) => (
            <ServiceCard key={s.id} service={s} className={'startPage'} onClick={onServiceClick} />
          ))}
          title={
            <div className={css.header}>
              <Link
                to={{
                  pathname: GLOBAL_SEARCH.path,
                  search: createSearchParams({
                    search: tabOptions.find((t) => t.id === type)?.name ?? ''
                  }).toString()
                }}>
                <p>Всі послуги</p> <EventLinkIcon />
              </Link>
              <h3>Послуги</h3>
            </div>
          }
          itemsToShow={services.length >= 3 ? 3 : services.length}
        />
      </div>
    </div>
  );
}
